<template>
  <div id="input-counter" class="flex">
    <span id="counter-label" class="uppercase text-sm text-fg-secondary font-label pr-1">
      {{ label }}
    </span>
    <span id="counter-value" class="text-8xl font-heading font-semibold -mt-2.5 pr-3">
      <slot>
        {{ value }}
      </slot>
    </span>
    <div class="flex flex-col justify-between items-center h-20">
      <SlotButton id="counter-plus-one" v-show="!isMax" :disabled="disabled" @click="addGuest" alt>
        +
      </SlotButton>
      <SlotButton
        id="counter-minus-one"
        v-show="!isMin"
        :disabled="disabled"
        @click="removeGuest"
        classes="mt-auto"
        alt
      >
        -
      </SlotButton>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import SlotButton from '@/common/components/atoms/SlotButton.vue'

export default defineComponent({
  name: 'InputCounter',
  components: {
    SlotButton,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    min: {
      type: Number,
      required: false,
    },
    max: {
      type: Number,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: {
    // eslint-disable-next-line no-unused-vars
    'update:value': (value: number) => true,
  },
  methods: {
    updateValue(value: number): void {
      if (this.disabled) return
      this.$emit('update:value', value)
    },
    addGuest(): void {
      if (this.max === undefined) this.updateValue(this.value + 1)
      else this.updateValue(this.value + 1 > this.max ? this.max : this.value + 1)
    },
    removeGuest(): void {
      if (this.min === undefined) this.updateValue(this.value - 1)
      else this.updateValue(this.value - 1 < this.min ? this.min : this.value - 1)
    },
  },
  computed: {
    isMax(): boolean {
      return this.max !== undefined && this.value >= this.max
    },
    isMin(): boolean {
      return this.min !== undefined && this.value <= this.min
    },
  },
})
</script>
